import { Route, Routes, BrowserRouter } from "react-router-dom";
import { useContext, useEffect } from "react";
import { setUser } from "../context/actions";
import { Context } from "../context/context";

import DashboardPage from "../components/dashboard/DashboardPage";
import TimeKeepingPage from "../components/timekeeping/TimeKeepingPage"
import MonthlySubmitsPage from "../components/submits/SubmitsPage"
import WorkRecordsPage from "../components/work-records/WorkRecordsPage"
import StatusOverviewPage from "../components/status-overview/StatusOverviewPage"
import UserAccessPage from "../components/user-access/UserAccessPage"
import InstituteConfigurationPage from "../components/institute-configuration/InstituteConfigurationPage";
import EmployeeBaseDataPage from "../components/employee-base-data/EmployeeBaseDataPage"
import UserSettingsPage from "../components/user-settings/UserSettingsPage"
import NotFoundPage from "../components/error/NotFoundPage";
import Layout from "../components/layout/Layout";
import BasePageLayout from "../components/layout/BasePageLayout";
import UserService from "../utils/UserService";
import { Trans, useTranslation } from 'react-i18next';
import i18next from "i18next";

import api from "../api";
import ProtectedRoute from "../utils/ProtectedRoute";

function AppRouter() {
    const date = new Date()
    const day = i18next.language === 'de' ? date.toLocaleString('de-de', { weekday: 'long' }) : date.toLocaleString('en-en', { weekday: 'long' });
    const dateString = i18next.language === 'de' ? date.toLocaleDateString('de-de') : date.toLocaleDateString('en-en');
    useTranslation();

    const [, dispatch] = useContext(Context);

    useEffect(() => {
        async function getUser() {
            const user = await api.readUser(UserService.getUserId());
            dispatch(setUser(user));
        };
        getUser();
    }, []);

    const roles = ['Mitarbeiter', 'Maintainer', 'Administrator', 'HR-Manager', 'Reporter']

    return (
        <BrowserRouter>
            <Routes>
                <Route element={<ProtectedRoute allowedRoles={roles} />}>
                    <Route path="/" element={<BasePageLayout title={`${day}, ${dateString}`}><DashboardPage /> </BasePageLayout>} />
                    <Route path="/timekeeper" element={<BasePageLayout title={<Trans i18nKey='zeiterfassung' ns='common'>Zeiterfassung</Trans>}><TimeKeepingPage /></BasePageLayout>} />
                    <Route path="/timekeeper/:id" element={<BasePageLayout title={<Trans i18nKey='zeiterfassung' ns='common'>Zeiterfassung</Trans>}><TimeKeepingPage /></BasePageLayout>} />
                    <Route path="/submits" element={<BasePageLayout title={<Trans i18nKey='monatsfreigabe' ns='common'>Monatsfreigabe</Trans>}><MonthlySubmitsPage /></BasePageLayout>} />
                    <Route path="/user-settings" element={<BasePageLayout title={<Trans i18nKey='persönlicheEinstellungen' ns='common'>Persönliche Einstellungen</Trans>}><UserSettingsPage /></BasePageLayout>} />
                </Route>
                <Route element={<ProtectedRoute allowedRoles={['Reporter']} />}>
                    <Route path="/work-records" element={<BasePageLayout title={<Trans i18nKey='export' ns='common'>Export von Arbeitsnachweisen</Trans>}><WorkRecordsPage /></BasePageLayout>} />
                    <Route path="/status-overview" element={<BasePageLayout title={<Trans i18nKey='statusübersicht' ns='common'>Statusübersicht</Trans>}><StatusOverviewPage /></BasePageLayout>} />
                </Route>
                <Route element={<ProtectedRoute allowedRoles={['Administrator']} />}>
                    <Route path="/user-access" element={<BasePageLayout title={<Trans i18nKey='nutzerzugänge' ns='common'>Nutzerzugänge</Trans>}><UserAccessPage /></BasePageLayout>} />
                </Route>
                <Route element={<ProtectedRoute allowedRoles={['HR-Manager']} />}>
                    <Route path="/employee-base-data" element={<BasePageLayout title={<Trans i18nKey='mitarbeiterStammdaten' ns='common'>Mitarbeiter Stammdaten</Trans>}><EmployeeBaseDataPage /></BasePageLayout>} />
                </Route>
                <Route element={<ProtectedRoute allowedRoles={['Maintainer']} />}>
                    <Route path="/institute-configuration/*" element={<BasePageLayout title={<Trans i18nKey='institutskonfiguration' ns='common'>Institutskonfiguration</Trans>}><InstituteConfigurationPage /></BasePageLayout>} />
                </Route>
                <Route path="*" element={<NotFoundPage />} />
            </Routes>
        </BrowserRouter>
    );
};

export default AppRouter
